import { changeCustomerBillToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";
import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { changeCustomerShipToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

changeCustomerShipToSelectorStyles.shipToSelectorDynamicDropdown = {
    cssOverrides: {
        list: css`
        max-height: 160px;
        >div[aria-selected^="true"] {
            color: ${getColor("common.background")};
            &:hover{
                color: ${getColor("secondary")}; 
            }
        }
        `,
        option: css`
        color: ${getColor("secondary")};
        &:hover{
            color: ${getColor("secondary")}; 
        }
        `,
    },
};

changeCustomerBillToSelectorStyles.billToSelectorDynamicDropdown = {
    cssOverrides: {
        list: css`
        >div[aria-selected^="true"] {
            color: ${getColor("common.background")};
            &:hover{
                color: ${getColor("secondary")}; 
            }
        }
        `,
        option: css`
        color: ${getColor("secondary")};
        &:hover{
            color: ${getColor("secondary")}; 
        }
        `,
    }
}

changeCustomerSelectCustomerContainerStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        margin-right: 15px;
    `,
}

changeCustomerSelectCustomerContainerStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        margin-bottom: 40px !important;
    `,
}

changeCustomerSelectCustomerContainerStyles.billToSelector = {
    billToSelectorDynamicDropdown: {
        cssOverrides: {
            list: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    max-height: 130px;
                    `,
                    null,
                    null,
                    null,
                    null,
            ])}
            `
        }
    }
}

changeCustomerSelectCustomerContainerStyles.shipToSelector = {
    shipToSelectorDynamicDropdown: {
        cssOverrides: {
            list: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    max-height: 100px;
                    `,
                    null,
                    null,
                    null,
                    null,
            ])}
            `
        }
    }
}
